<template>
  <div>
    <file-pond
      allow-multiple="true"
      max-files="100"
      credits="false"
      name="file"
      ref="input"
      itemInsertLocation="after"
      :onremovefile="onremovefile"
      :beforeRemoveFile="beforeRemove"
      allowFileTypeValidation="true"
      acceptedFileTypes="image/jpeg, image/png"
      filePosterMaxHeight="100"
      imagePreviewHeight="100"
      :server="{ process, revert, restore, load, fetch: null }"
      :files="files"
      @init="handleFilePondInit"
    />
  </div>
</template>
<script>
/* eslint-disable no-unused-vars */

import API from '../../api';
import axios from 'axios';

// Import Vue FilePond
import vueFilePond from 'vue-filepond';

// Import FilePond styles
import 'filepond/dist/filepond.min.css';

// Import FilePond plugins
// Please note that you need to install these plugins separately

// Import image preview plugin styles
import 'filepond-plugin-image-preview/dist/filepond-plugin-image-preview.min.css';

// Import image preview and file type validation plugins
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
// Import the plugin code
import FilePondPluginFilePoster from 'filepond-plugin-file-poster';

// Import the plugin styles
import 'filepond-plugin-file-poster/dist/filepond-plugin-file-poster.css';

// Register the plugin
// Create component
const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview, FilePondPluginFilePoster);
//Vue.use(FilePond);

/* eslint-disable no-debugger */

//import API from '../../api';
let imageFiles = {};

/* eslint-disable-next-line  */
export default {
  name: 'Library',
  props: {
    product: {
      type: [Object]
    }
  },

  components: {
    FilePond
    //Matching,
    //Tags,
  },

  data: () => ({
    files: [],
    images: []
  }),
  //LOAD
  created: async function () {
    this.error = null;
    let res = await API.get('product/' + this.product.uuid);
    if (!res) {
      return;
    }
    if (res.errors && res.errors.length > 0) {
      this.error = res.errors[0].msg;
    } else {
      this.error = null;

      this.images = res.data.images;
    }
  },
  mounted() {
    document.title = 'Edit Product Images';
  },
  methods: {
    process(fieldName, file, metadata, load, error, progress, abort) {
      const CancelToken = axios.CancelToken;
      const source = CancelToken.source();
      let cancelled = false;

      (async () => {
        try {
          // Step 1: ask the backend for a presigned S3 URL + uuid/key for this file
          let presignedRes = await API.post('file/presigned-url', {
            fileType: 'product',
            fileName: file.name,
            contentType: file.type || 'application/octet-stream',
            needsThumbnail: false
          });

          if (presignedRes.errors && presignedRes.errors.length > 0) {
            error(presignedRes.errors[0].msg);
            return;
          }

          let { uuid, key, presignedUrl } = presignedRes.data;

          if (cancelled) return;

          // Step 2: upload the file directly to S3 using the presigned URL,
          // reporting progress back to FilePond and honoring cancellation.
          const s3Axios = axios.create();
          delete s3Axios.defaults.headers.common['Authorization'];

          await s3Axios.put(presignedUrl, file, {
            headers: {
              'Content-Type': file.type || 'application/octet-stream'
            },
            cancelToken: source.token,
            onUploadProgress: e => {
              progress(e.lengthComputable, e.loaded, e.total);
            }
          });

          if (cancelled) return;

          // Step 3: confirm the upload with the backend so a UserFile row gets created
          let confirmRes = await API.post('file/confirm-upload', {
            uuid,
            key,
            fileName: file.name,
            fileType: 'product',
            otherObjectId: this.product.id
          });

          if (confirmRes.errors && confirmRes.errors.length > 0) {
            error(confirmRes.errors[0].msg);
            return;
          }

          // passing the file id to FilePond
          load(confirmRes.data.uuid);
        } catch (thrown) {
          if (axios.isCancel(thrown)) {
            console.log('Request canceled', thrown.message);
          } else {
            error(thrown.message || 'Upload failed');
          }
        }
      })();

      // Setup abort interface
      return {
        abort: () => {
          cancelled = true;
          source.cancel('Operation canceled by the user.');
          abort();
        }
      };
    },
    async onremovefile(err, file) {
      if (file && file.serverId) {
        this.revert(file.serverId);
      }
    },
    async revert(uniqueFileId, load, error) {
      try {
        let res = await API.post('file/delete', {
          uuid: uniqueFileId
        });
        if (load) {
          load();
        }
      } catch {
        if (error) {
          error();
        }
      }
    },
    beforeRemove: file => {},
    load: (uniqueFileId, load, error, progress, abort, headers) => {
      let file = imageFiles[uniqueFileId];
      fetch(file.url)
        .then(res => {
          console.log(res);
          return res.blob();
        })
        .then(load);
    },
    fetch(url, load, error, progress, abort, headers) {
      error('not supported');
    },
    restore(uniqueFileId, load, error, progress, abort, headers) {
      error();
    },
    handleError(error, e) {
      switch (e.code) {
        case 'storage/canceled':
          break;
        default:
          error(e.message);
      }
    },
    handleFilePondInit: function () {
      //this.$refs.input.getFiles();
    }
  },
  watch: {
    images: {
      immediate: true,
      handler: function (images, oldVal) {
        let files = [];

        for (let index = 0; index < images.length; index++) {
          const image = images[index];
          imageFiles[image.uuid] = image;
          let file = {
            // the server file reference
            source: image.uuid,

            // set type to local to indicate an already uploaded file
            options: {
              type: 'local'
            }
          };
          files.push(file);
        }
        this.files = files;
      }
    }
  }
};
</script>

<style>
.avatar {
  width: 140px !important;
  height: 140px !important;
  top: -70px !important;
  left: 30px !important;
  border: 5px solid #fff;
}
.filepond--item {
  width: calc(50% - 0.5em);
}
</style>
